import React from "react";
import { vanarExplorerUrl } from "../utils/constants";
import {
    formatNumber,
    getTruncatedTrx,
    getValidatorImg,
} from "../utils/helper";
import { useMediaQuery } from "react-responsive";
import ClipLoaderComponent from "./loader/ClipLoaderComponent";
import BeatLoaderComponent from "./loader/BeatLoaderComponent";

function ClaimUnstake({
    setInputValue,
    setIsUnStakeAmountConfirmed,
    isConfirmDisabled,
    selectedValidator,
    unStakeClaimTrx,
    setIsTermsAgreed
}) {
    const isMobile = useMediaQuery({ query: "(max-width: 490px)" });
    const totalValue = unStakeClaimTrx?.reduce(
        (sum, item) => sum + item.value,
        0,
    );

    const roundedTotalValue = Math.round(totalValue * 100) / 100;

    const convertDate = (seconds) => {
        // Convert to milliseconds and then to a date
        const date = new Date(seconds * 1000);

        // Format the date to 'DD MMM YYYY'
        const formattedDate = date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
        return formattedDate;
    };

    return (
        <div className="flex items-center justify-center w-full h-auto xsm:h-full md:px-4 forMobile">
            <div className="max-w-[1200px] w-full bg-[#121212] border-[#1A1A1ACC] rounded-3xl pt-6 pb-11 md:py-10 px-4 md:px-9 mx-auto">
                <div className="flex flex-col xsm:grid lg:grid-cols-2 gap-6 md:gap-8 *:col-span-1">
                    <div className="flex flex-col items-center md:items-start text-center md:text-left justify-between">
                        <div>
                            <h4 className="text-textcolor text-xxl md:text-[34px] leading-none font-bold md:font-semibold capitalize mb-3">
                                Verify Your Unstake Claim
                            </h4>
                            <p className="text-xsm md:text-sm font-normal text-dim/50 max-w-[350px] mb-6 md:mb-0">
                                Please take a review before proceeding to the
                                next steps
                            </p>
                            <div className="my-8 bg-white/[0.04] h-[1px] w-[88px] hidden md:block"></div>
                        </div>
                        <div className="flex items-center flex-col md:flex-row gap-4">
                            <div className="flex items-center justify-center p-3 md:p-[10px] w-[59px] h-[59px] md:w-[74px] md:h-[74px] rounded-2xl bg-[#010101]">
                                <img
                                    src={getValidatorImg(selectedValidator?.name)}
                                    alt=""
                                    className=""
                                />
                            </div>
                            <div className="flex flex-col gap-[10px]">
                                <h4 className="text-sm md:text-xl font-medium leading-4 md:leading-6 text-primaryWhite">
                                    {selectedValidator?.name}
                                </h4>
                                <ul className="flex space-x-2 md:space-x-4">
                                    {/* <li className="text-sm md:text-base font-normal leading-7 text-primaryWhite/50">
                                        <span className="text-green mr-1">
                                            {selectedValidator?.performance
                                                ? selectedValidator?.performance
                                                : "0%"}
                                        </span>
                                        Performance
                                    </li> */}
                                    <li className="text-sm md:text-base font-normal leading-7 text-primaryWhite/50">
                                        <span className="text-green mr-1">
                                            {selectedValidator?.commission
                                                ? selectedValidator?.commission *
                                                100 +
                                                "%"
                                                : "0%"}
                                        </span>
                                        Commission
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <div className="bg-[#1A1A1A] border-[1.5px] border-white/[0.02] h-auto min-h-[290px] rounded-2xl w-full overflow-hidden">
                            <div className="flex flex-col gap-3 bg-[#020303] border border-[#020303] px-6 py-4">
                                <h4 className="text-sm leading-6 text-dim/40">
                                    Total Unstake Amount
                                </h4>
                                <h2 className="text-[28px]/8 md:text-[38px]/[38px] font-bold w-full">
                                    {roundedTotalValue === 0 ? <div className="flex items-left justify-left"> <BeatLoaderComponent size={10} /></div>
                                        : formatNumber(roundedTotalValue)}
                                </h2>
                            </div>
                            <ul className="px-6 py-5 space-y-7 max-h-[170px] overflow-auto">
                                <p className="text-xsm/5 md:text-sm/6 text-dim/40">
                                    Summary of your Unstaking transactions
                                </p>
                                {unStakeClaimTrx?.length === 0 && <ClipLoaderComponent
                                    size={40}
                                    customClass={"justify-center"}
                                />}
                                {unStakeClaimTrx?.length > 0 && unStakeClaimTrx?.map((trx) => (
                                    <li className="flex items-center justify-between gap-2" key={trx.id}>
                                        <h3 className="text-xl/5 md:text-xxl/6 font-semibold text-dim flex items-center min-w-20">
                                            {formatNumber(trx?.value)}
                                        </h3>
                                        <span
                                            className="text-tagcolor text-xsm/4 md:text-sm/4 font-normal underline hover:cursor-pointer"
                                            onClick={() => {
                                                window.open(
                                                    `${vanarExplorerUrl}/tx/${trx?.id}`,
                                                    "_blank",
                                                );
                                            }}
                                        >
                                            {getTruncatedTrx(trx?.id, isMobile
                                                ? 10 : 22)}
                                        </span>
                                        <span className="text-[#50FDDB] text-xsm/4 md:text-sm/4 font-medium xsm:whitespace-nowrap">
                                            {convertDate(trx?.date)}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="mt-5 md:mt-[30px]">
                            <button
                                disabled={isConfirmDisabled}
                                onClick={() => {
                                    setIsUnStakeAmountConfirmed(true);
                                    setIsTermsAgreed(true);
                                    setInputValue(roundedTotalValue);
                                }}
                                type="button"
                                className={`${isConfirmDisabled
                                    ? "opacity-50 cursor-not-allowed"
                                    : "cursor-pointer"
                                    }inline-flex justify-center items-center bg-transparent text-xsm lg:text-sm leading-[24px] font-semibold rounded-full outline-0 -tracking-[0.42] duration-300 primary-gradient w-full p-[15px] md:p-[21px] capitalize`}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ClaimUnstake;
